export const CloudsIcon = () => (
	<svg
		width="103"
		height="104"
		viewBox="0 0 103 104"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M76.2387 42.2507C75.9353 42.2507 75.6394 42.2545 75.3398 42.2657C70.7703 30.5462 61.167 25.6396 46.8519 25.6396C26.3343 25.6396 15.0754 35.9059 15.0754 62.2552H97.4792C95.157 49.1536 87.3065 42.2507 76.235 42.2507H76.2387Z"
			fill="#1868DB"
		/>
		<path
			d="M16.0231 65.7947H36.7355C34.8815 55.3299 28.6116 49.8203 19.7686 49.8203C11.5323 49.8203 5.94786 54.004 2.64062 65.7947H16.0231Z"
			fill="#BF63F3"
		/>
		<path
			d="M19.7684 49.8203C18.465 49.8203 17.2327 49.9252 16.0604 50.1499C15.4124 53.7381 15.0791 57.7569 15.0791 62.2552H35.8814C33.3419 54.0939 27.5552 49.8241 19.7684 49.8241V49.8203Z"
			fill="#09326C"
		/>
		<path
			d="M41.5483 66.6149C41.7917 66.6149 42.0314 66.6187 42.2711 66.6262C45.9454 57.2101 53.6611 53.2661 65.1596 53.2661C81.6471 53.2661 90.6924 61.5173 90.6924 82.6867H24.4802C26.3455 72.1582 32.6528 66.6149 41.552 66.6149H41.5483Z"
			fill="#1868DB"
		/>
		<path
			d="M85.8495 62.2515C81.5872 55.9741 74.5981 53.2661 65.1633 53.2661C55.7285 53.2661 48.7133 55.9741 44.5259 62.2515H85.8495Z"
			fill="#09326C"
		/>
	</svg>
);
